webpackJsonp([253764239216394],{

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _step = __webpack_require__(96);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 6: Add Logout Page'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to add a logout experience.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'authentication.6' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create the Logout Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While we don\'t have a "logout page" in a visual sense, we still have behavior that we want executed when the user logs out, such as removing their user token and redirecting them to the login page.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We\'re going to store this behavior in a component so that we can have it execute when the user navigates to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/logout'
	      ),
	      ' route.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Start by creating a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Logout'
	      ),
	      ' component:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component Logout\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then update the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Logout'
	      ),
	      ' component to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import auth from \'../utils/auth\';\n        import ShowLoadingScreen from \'./ShowLoadingScreen\';\n\n        export default createReactClass({\n          displayName: \'Logout\',\n\n          propTypes: {\n            router: PropTypes.object.isRequired\n          },\n\n          componentDidMount() {\n            const { router } = this.props;\n\n            auth.deleteToken();\n            router.push(\'/\');\n          },\n\n          render() {\n            return (\n              <ShowLoadingScreen/>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import auth from \'../utils/auth\';\n        import ShowLoadingScreen from \'./ShowLoadingScreen\';\n\n        class Logout extends React.Component {\n\n          componentDidMount() {\n            const { router } = this.props;\n\n            auth.deleteToken();\n            router.push(\'/\');\n          }\n\n          render() {\n            return (\n              <ShowLoadingScreen/>\n            );\n          }\n\n        }\n\n        Logout.propTypes = {\n          router: PropTypes.object.isRequired\n        };\n\n        export default Logout;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import auth from \'../utils/auth\';\n        import ShowLoadingScreen from \'./ShowLoadingScreen\';\n\n        class Logout extends React.Component {\n\n          static propTypes = {\n            router: PropTypes.object.isRequired\n          };\n\n          componentDidMount() {\n            const { router } = this.props;\n\n            auth.deleteToken();\n            router.push(\'/\');\n          }\n\n          render() {\n            return (\n              <ShowLoadingScreen/>\n            );\n          }\n\n        }\n\n        export default Logout;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add the /logout route'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next import the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Logout'
	      ),
	      ' component into ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'routes.js'
	      ),
	      ' and update the routes to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // routes.js\n      ...\n      import Logout from \'./src/components/Logout\';\n\n      export default (\n        <Route>\n          <Route path="/login" component={Login} />\n          <Route path="/logout" component={Logout} />\n          <Route path="/auth/callback" component={AuthCallback} />\n\n          ...\n        </Route>\n      );\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Convert Logout Button to Link'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Finally, we need to make it so that when the user clicks the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Logout'
	      ),
	      ' button in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Profile'
	      ),
	      ' component they are redirected to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/logout'
	      ),
	      ' route, which will delete their user token and redirect them to the login page.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Locate the Logout button in your ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Profile'
	      ),
	      ' component:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Profile.js\n      <button className="btn btn-primary">\n        Log out\n      </button>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Convert this button to a React Router ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Link'
	      ),
	      ' and have it point to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/logout'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Profile.js\n      import { Link } from \'react-router\';\n      ...\n        render() {\n          ...\n            <Link className="btn btn-primary" to="/logout">\n              Log out\n            </Link>\n          ...\n        }\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With this change in place, clicking the Logout button will redirect you to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/logout'
	      ),
	      ', and once you log in, you\'ll be redirected to the main application.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _step2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Logout.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import auth from \'../utils/auth\';\n        import ShowLoadingScreen from \'./ShowLoadingScreen\';\n\n        export default createReactClass({\n          displayName: \'Logout\',\n\n          propTypes: {\n            router: PropTypes.object.isRequired\n          },\n\n          componentDidMount() {\n            const { router } = this.props;\n\n            auth.deleteToken();\n            router.push(\'/\');\n          },\n\n          render() {\n            return (\n              <ShowLoadingScreen/>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import auth from \'../utils/auth\';\n        import ShowLoadingScreen from \'./ShowLoadingScreen\';\n\n        class Logout extends React.Component {\n\n          componentDidMount() {\n            const { router } = this.props;\n\n            auth.deleteToken();\n            router.push(\'/\');\n          }\n\n          render() {\n            return (\n              <ShowLoadingScreen/>\n            );\n          }\n\n        }\n\n        Logout.propTypes = {\n          router: PropTypes.object.isRequired\n        };\n\n        export default Logout;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import auth from \'../utils/auth\';\n        import ShowLoadingScreen from \'./ShowLoadingScreen\';\n\n        class Logout extends React.Component {\n\n          static propTypes = {\n            router: PropTypes.object.isRequired\n          };\n\n          componentDidMount() {\n            const { router } = this.props;\n\n            auth.deleteToken();\n            router.push(\'/\');\n          }\n\n          render() {\n            return (\n              <ShowLoadingScreen/>\n            );\n          }\n\n        }\n\n        export default Logout;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'routes.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import { Route, IndexRoute, Redirect } from \'react-router\';\n\n      /**\n       * Wrapping the Master component with this decorator provides an easy way\n       * to redirect the user to a login experience if we don\'t know who they are.\n       */\n      import UserIsAuthenticated from \'./src/decorators/UserIsAuthenticated\';\n\n      /**\n       * Routes are used to declare your view hierarchy\n       * See: https://github.com/ReactTraining/react-router/blob/v3/docs/API.md\n       */\n      import Master from \'./src/components/Master\';\n      import Layout from \'./src/components/Layout\';\n      import Feed from \'./src/components/Feed\';\n      import Login from \'./src/components/Login\';\n      import AuthCallback from \'./src/components/AuthCallback\';\n      import Logout from \'./src/components/Logout\';\n\n      export default (\n        <Route>\n          <Route path="/login" component={Login} />\n          <Route path="/logout" component={Logout} />\n          <Route path="/auth/callback" component={AuthCallback} />\n\n          <Route component={UserIsAuthenticated(Master)}>\n            <Route path="/" component={Layout}>\n              <IndexRoute component={Feed} />\n            </Route>\n          </Route>\n        </Route>\n      );\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Profile.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        export default createReactClass({\n          displayName: \'Profile\',\n\n          propTypes: {\n            user: PropTypes.object.isRequired\n          },\n\n          getDefaultProps() {\n            return {\n              user: {\n                id: 1,\n                data: {\n                  nickname: \'ayla\',\n                  avatar: \'https://cloud.githubusercontent.com/assets/2637399/19027069/a356e82a-88e1-11e6-87d8-e3e74f55c069.png\'\n                }\n              }\n            };\n          },\n\n          render() {\n            const { user } = this.props;\n\n            return (\n              <div className="card profile">\n                <div className="card-block">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                  <h4 className="card-title">\n                    Hi {user.data.nickname}!\n                  </h4>\n                  <div className="card-text">\n                    <p>You have permission to perform the following:</p>\n                    <ul className="permissions">\n                      <li>Create Tweets</li>\n                      <li>Edit your own tweets</li>\n                      <li>Delete your own tweets</li>\n                    </ul>\n                  </div>\n                  <Link className="btn btn-primary" to="/logout">\n                    Log out\n                  </Link>\n                </div>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        class Profile extends React.Component {\n\n          render() {\n            const { user } = this.props;\n\n            return (\n              <div className="card profile">\n                <div className="card-block">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                  <h4 className="card-title">\n                    Hi {user.data.nickname}!\n                  </h4>\n                  <div className="card-text">\n                    <p>You have permission to perform the following:</p>\n                    <ul className="permissions">\n                      <li>Create Tweets</li>\n                      <li>Edit your own tweets</li>\n                      <li>Delete your own tweets</li>\n                    </ul>\n                  </div>\n                  <Link className="btn btn-primary" to="/logout">\n                    Log out\n                  </Link>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        Profile.propTypes = {\n          user: PropTypes.object.isRequired\n        };\n\n        Profile.defaultProps = {\n          user: {\n            id: 1,\n            data: {\n              nickname: \'ayla\',\n              avatar: \'https://cloud.githubusercontent.com/assets/2637399/19027069/a356e82a-88e1-11e6-87d8-e3e74f55c069.png\'\n            }\n          }\n        };\n\n        export default Profile;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import { Link } from \'react-router\';\n\n        class Profile extends React.Component {\n\n          static propTypes = {\n            user: PropTypes.object.isRequired\n          };\n\n          static defaultProps = {\n            user: {\n              id: 1,\n              data: {\n                nickname: \'ayla\',\n                avatar: \'https://cloud.githubusercontent.com/assets/2637399/19027069/a356e82a-88e1-11e6-87d8-e3e74f55c069.png\'\n              }\n            }\n          };\n\n          render() {\n            const { user } = this.props;\n\n            return (\n              <div className="card profile">\n                <div className="card-block">\n                  <img\n                    className="img-circle avatar"\n                    src={user.data.avatar} />\n                  <h4 className="card-title">\n                    Hi {user.data.nickname}!\n                  </h4>\n                  <div className="card-text">\n                    <p>You have permission to perform the following:</p>\n                    <ul className="permissions">\n                      <li>Create Tweets</li>\n                      <li>Edit your own tweets</li>\n                      <li>Delete your own tweets</li>\n                    </ul>\n                  </div>\n                  <Link className="btn btn-primary" to="/logout">\n                    Log out\n                  </Link>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Profile;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-7/' },
	        'add an endpoint to the mock API that we can use to retrieve the current user'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-authentication-step-6-js-6a9af360b2ed1494fab6.js